import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import Router from './Router'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import { config as i18nextConfig } from '../../translations'

i18next.init(i18nextConfig)

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter basename="/">
            <I18nextProvider i18n={i18next}>
              <Router />
            </I18nextProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </div>
  )
}

export default App
